import logo1 from "./smglasbamladih.png"
import gm2021 from "./gmSezona2021.png"
import gm2022 from "./gm2022.png"
import gmplace2021 from "./gmplace2021.jpg"
import gmplace20212 from "./gmplace20212.jpg"
import gmplace2022 from "./gmplace2022.jpg"
import gmplace2023 from "./gmplace2023.jpg"
import gmplace2024 from "./gmplace2024.jpg"


export const gmSezone = [
    {
        leto: 2021,
        ime: "Sezona 2021",
        slika1: gmplace2021,
        slika2: gmplace20212,
        logo: gm2021,
        naslov: "Glasba mladih",
        vsebina: "Premierna izvedba skupne ideje o skladateljskem koncertu mladih ustvarjalcev. Takratni maturantje Konservatorija za glasbo in balet Ljubljana so na pobudo mladega skladatelja Vida Ožbolta zorganizirali koncert nove komorne glasbe, preostanek skladb so napisali njihovi sošolci in znanci. Na krstnem koncertu v Radovljici je publika napolnila cerkev sv. Petra in mladim dala zagon za nadaljevanje s projektom.\n",
        program1: [
            {
                skladatelj: "Tilen Slakan",
                naslov: "Godalni kvartet št. 1",
            },
            {
                skladatelj: "Lan Podletnik Ašič",
                naslov: "Sanje za klavirski trio",
            },
            {
                skladatelj: "Sara Bartha Rijavec",
                naslov: "Del celote za klavirski kvartet",
            },
            {
                skladatelj: "Lan Podletnik Ašič",
                naslov: "Del celote za klavirski kvartet",
            },
            {
                skladatelj: "Martin Vasle",
                naslov: "Tempo de maio za godalni kvartet",
            },
            {
                skladatelj: "Vid Ožbolt",
                naslov: "Klavirski kvintet ",
            },
        ],
        izvajalci: [
            { ime: "Neža Tovšak", instrument: "klavir" },
            { ime: "Timotej Willewaldt", instrument: "violina" },
            { ime: "Laura de Wolff", instrument: "violina" },
            { ime: "Manca Kosmač", instrument: "viola" },
            { ime: "Sofia Grassi", instrument: "violončelo" }
        ],
        linki: [
            {
                text: "Posnetke koncerta si lahko ogledate na našem YouTube kanalu",
                link: "https://www.youtube.com/@glasbamladih"
            },
            {
                text: "Klavirski kvintet Vida Ožbolta pa je bil tudi arhivsko posnet in predvajan na Radiu Ars",
                link: "https://ars.rtvslo.si/podkast/nove-glasbene-generacije/15104115/174846238"
            }
        ],
    },



    {
        leto: 2022,
        ime: "Sezona 2022",
        slika1: gm2022,
        slika2: "path/to/slika2-2022.jpg",
        logo: gmplace2022,
        naslov: "Glasba mladih II",
        vsebina: "Druga izvedba projekta je prinesla večjo zasedbo, nove skladatelje in več koncertov. Premierni koncert je bil izveden v radovljiški župnijski cerkvi sv. Petra, posnela ga je ekipa RTV Slovenija. Projekt smo predstavili še v dvorani Pokrajinskega muzeja Koper, Dvorani Lucijana Marije Škerjanca na Konservatoriju za glasbo in balet Ljubljana in v Kulturnem domu Postojna.",
        program1: [
            {
                skladatelj: "Krištof Strnad",
                naslov: "Genesis za klavirski kvintet"
            },
            {
                skladatelj: "Sofia Grassi",
                naslov: "Za sončnimi okni za flavto, bas klarinet in violončelo"
            },
            {
                skladatelj: "Žiga Čopi",
                naslov: "Sunflower seeds (Sončnična semena) za godalni kvartet in fagot"
            },
            {
                skladatelj: "Matej Kastelic",
                naslov: "Agnus Dei (Jagnje Božje) za sopran, klavir in violončelo"
            },
            {
                skladatelj: "Martin Vasle",
                naslov: "Date (Zmenek) za harfo, flavto, klarinet in godalni kvartet"
            },
            {
                skladatelj: "Vid Ožbolt",
                naslov: "Tri pesmi za sopran, flavto, klarinet, fagot, harfo, klavir in godalni kvartet"
            }
        ],
        izvajalci: [
            { ime: "Maja Triler", instrument: "sopran" },
            { ime: "An Černe", instrument: "flavta" },
            { ime: "Tadeja Malc", instrument: "klarinet" },
            { ime: "Eva Fritz", instrument: "fagot" },
            { ime: "Sara Bajc", instrument: "harfa" },
            { ime: "Neža Tovšak", instrument: "klavir" },
            { ime: "Timotej Willewaldt", instrument: "violina" },
            { ime: "Laura de Wolff", instrument: "violina" },
            { ime: "Manca Kosmač", instrument: "viola" },
            { ime: "Sofia Grassi", instrument: "violončelo" },
            { ime: "Vid Ožbolt", instrument: "dirigent" }
        ],
        linki: [
            {
                text: "ARS 1. del koncerta",
                link: "https://ars.rtvslo.si/podkast/nove-glasbene-generacije/15104115/174900231"
            },
            {
                text: "ARS 2. del koncerta",
                link: "https://ars.rtvslo.si/podkast/mladi-virtuozi/15104166/174900969"
            }
        ],
    },



    {
        leto: 2023,
        ime: "Sezona 2023",
        slika1: "path/to/slika1-2023.jpg",
        slika2: "path/to/slika2-2023.jpg",
        logo: gmplace2023,


        naslov1: "Mala mlada glasba",
        vsebina1: "Mala mlada glasba je koncertni projekt, prinaša svež veter v slovenski prostor sodobne klasične glasbe. Mlade skladateljice in skladatelji ter izvrstni mladi izvajalci so povezali moči in pripravili pester program del za manjše komorne zasedbe. Koncert je bil zasnovan kot priložnost za prvo izvedbo novih kompozicij ter ponovno oživitev že obstoječih mladih stvaritev.\n Večer se je oblikoval v dve programski celoti, ki sta skupaj ponudili širok slogovni in izrazni razpon – od intimnih duetov do dinamičnih pihalnih kvintetov.",
        oProjektu: "Projekt Mala mlada glasba je nastal z željo po spodbujanju rednega izvajanja del mladih slovenskih skladateljev in skladateljic, pisanih za komorne zasedbe do petih članov. Letos smo program oblikovali s kombinacijo skladb, izbranih prek razpisa, in del, ki so bila posebej naročena ali izbrana za aktualno zasedbo izvajalcev.\n" +
            "Projekt spodbuja ponovne izvedbe mladih del in vstop teh skladb v repertoarje slovenskih komornih skupin, obenem pa odpira nove priložnosti za uveljavljanje mladih ustvarjalcev in izvajalcev.",
        vizija: "Z vsakoletnim koncertom Mala mlada glasba želimo ustvariti tradicijo, ki bi širila prostor za novo komorno glasbo v Sloveniji. Naš cilj je pokazati, da sodobna klasična glasba lahko nagovarja širok krog poslušalcev in odpira nova umetniška obzorja – tudi za tiste, ki jim je klasična glasba morda še neznana.",
        programMmg: [
            {
                skladatelj: "Lucio Žganec (2002*)",
                naslov: "Brez miru za pihalni kvintet*",
            },
            {
                skladatelj: "Jurij Mušič (2003*)",
                naslov: "La danza de los fantasmas (Ples duhov) za klarinet, klavir in kontrabas",
            },
            {
                skladatelj: "Matic Petek (2002*)",
                naslov: "Duet za violino in violončelo",
            },
            {
                skladatelj: "Lan Podletnik Ašič (2002*)",
                naslov: "-   -- . ... ... .- --. . (Message) za pihalni kvintet (črtice in pikce so naslov skladbe v morsejevi abecedi)",
            },
            {
                skladatelj: "Lara Oprešnik (1997*)",
                naslov: "Modrina za oboo in klavir",
            },
            {
                skladatelj: "Leon Firšt (1993*)",
                naslov: "Interferenca za pihalni kvintet",
            },
            {
                skladatelj: "Blaž Pirnat (2004*)",
                naslov: "Carousel za klarinet, klavir in violončelo ",
            },
            {
                skladatelj: "Tilen Slakan (1993*)",
                naslov: "Gemini za pihalni kvartet, Trio Affetuoso za klavirski trio",
            },
        ],
        linkiMmg: [
            {
                text: "ARS povezava 1",
                link: "https://ars.rtvslo.si/podkast/nove-glasbene-generacije/15104115/175009721"
            },
            {
                text: "ARS povezava 2",
                link: "https://ars.rtvslo.si/podkast/nove-glasbene-generacije/15104115/175007995"
            }
        ],


        naslov: "Glasba mladih III",
        vsebina: "Celovečerni koncert nove glasbe \n" +
            "za večje komorne zasedbe\n" +
            "Tretji celovečerni koncert nove glasbe, napisane za inštrumentalne zasedbe do 11 izvajalcev. Vse skladbe so bile izvedene krstno in napisane prav za ta projekt.\n",
        program1: [
            {
                skladatelj: "Matej Zupančič (2000*)",
                naslov: "Skrite želje za rog in godalni kvartet"
            },
            {
                skladatelj: "Jakob Korošec (2004*)",
                naslov: "Modal mixture za flavto, rog, marimbo in violončelo  "
            },
            {
                skladatelj: "Lucio Žganec (2003*)",
                naslov: "Amour pour deux za klavirski kvintet"
            },
            {
                skladatelj: "Simon Kravos (1999*)",
                naslov: "Melody? za flavto, klarinet, rog, tolkala, klavir in godalni kvartet"
            },
            {
                skladatelj: "Eva Ostanek (1998*)",
                naslov: "Ionescov profesor za bariton, flavto, klarinet, rog, tolkala, klavir in godalni kvartet"
            }
        ],
        izvajalci: [
            { ime: "Andraž Fink", instrument: "bariton" },
            { ime: "Lara Willewaldt", instrument: "dirigentka" },
            { ime: "Maša Majcen", instrument: "flavta" },
            { ime: "Tadeja Malc", instrument: "klarinet" },
            { ime: "David Tretjak", instrument: "rog" },
            { ime: "Tilen Zlatnar", instrument: "tolkala" },
            { ime: "Radoš Bone", instrument: "tolkala" },
            { ime: "Vid Ibic", instrument: "klavir" },
            { ime: "Timotej Willewaldt", instrument: "violina" },
            { ime: "Laura de Wolff", instrument: "violina" },
            { ime: "Patricija Malovrh Mlačnik", instrument: "viola" },
            { ime: "Ariel Vei Atanasovski", instrument: "violončelo" }
        ],



        naslov2: "Grajski duhovi",
        vsebina2: "Slovenske legende, miti in pripovedke v glasbeni preobrazbi\n" +
            "9. 12. 2023 ob 19. uri, Baročna dvorana radovljiške graščine\n" +
            "Koncert nove glasbe po navdihu stare literature in umetnosti. Projekt je zgrajen okoli slovenske mitološke literature, v starih ali sodobnih prepisih. Mladi skladatelji so z raznoliko zasedbo ustvarili enovita in samostojna glasbeno dramska dela.\n",
        program2: [
            {
                skladatelj: "Eva Ostanek (2000*)",
                naslov: "Medeja (D. Zajc)"
            },
            {
                skladatelj: "Jurij Mušič (2003*)",
                naslov: "Od Rošlina in Verjankota (F. Prešeren/ljudska)"
            },
            {
                skladatelj: "Miha Nahtigal (1994*)",
                naslov: "Legenda o Cerkniškem jezeru (ljudska)"
            },
            {
                skladatelj: "Vid Ožbolt (2002*)",
                naslov: "Lepa Vida (F. Prešeren/ljudska)"
            },
        ],
        izvajalci2: [
            { ime: "Adna Cinac", instrument: "sopran" },
            { ime: "Andraž Fink", instrument: "bariton" },
            { ime: "Tilen Udovič", instrument: "pripovedovalec" },
            { ime: "Jakob Ivačič", instrument: "dirigent" },
            { ime: "Nuša Dolinšek", instrument: "flavta" },
            { ime: "Luka Vovk", instrument: "klarinet" },
            { ime: "David Tretjak", instrument: "rog" },
            { ime: "Amadej Štrajhar", instrument: "trobenta" },
            { ime: "Blaž Kozjek", instrument: "pozavna" },
            { ime: "Samo Novak", instrument: "teorba" },
            { ime: "Timotej Willewaldt", instrument: "violina" },
            { ime: "Laura Bartelj", instrument: "violina" },
            { ime: "Patricija Malovrh Mlačnik", instrument: "viola" },
            { ime: "Nuša Planinc", instrument: "violončelo" }
        ],
        linki2: [
            {
                text: "ARS povezava 1",
                link: "https://ars.rtvslo.si/podkast/nove-glasbene-generacije/15104115/175042354"
            },
            {
                text: "ARS povezava 2",
                link: "https://ars.rtvslo.si/podkast/nove-glasbene-generacije/15104115/175043722"
            }
        ],
    },



    {
        leto: 2024,
        ime: "Sezona 2024",
        slika1: "path/to/slika1-2024.jpg",
        slika2: "path/to/slika2-2024.jpg",
        logo: gmplace2024,
        naslov: "Glasba mladih IV",
        vsebina: "Projekt Glasba mladih tudi letos ponosno nadaljuje svojo pot s četrto izdajo koncertnega večera, posvečenega izključno mladim slovenskim skladateljem in njihovi najnovejši ustvarjalnosti. Na koncertu Glasba mladih IV so obiskovalci doživeli šest krstnih izvedb izpod peres nekaterih najbolj obetavnih mladih umetnikov.\n" +
            "Pod glasbenim vodstvom dirigentke Lare Willewaldt je Ansambel Glasba mladih izvedel raznolik in vsebinsko bogat program, ki je s svojo svežino in izrazno močjo znova dokazal, da ima slovenska sodobna glasba izjemno prihodnost.\n",

        oProjektugmvi: "Glasba mladih je iniciativa, ki podpira izvajanje, pisanje in promocijo novonastale klasične glasbe slovenskih mladih skladateljev. Nastala je leta 2021 z vizijo ustvarjanja profesionalnih priložnosti za mlade umetnike in se od leta 2023 razvija pod okriljem Kulturnega društva Odeon.\n" +
            "Namen projekta je omogočiti kakovostne izvedbe novih del in tako prispevati k razvoju slovenske sodobne glasbe ter približati novo umetnost širšemu občinstvu.\n" +
            "Glasba mladih IV nadaljuje tradicijo, ki spodbuja povezovanje ustvarjalcev in izvajalcev ter ustvarja most med mlado umetniško generacijo in publiko.\n",
        naslov3: "Ansanbel Glasba mladih",
        vsebina3: "Ansambel Glasba mladih sestavljajo izjemni mladi glasbeniki – študenti, dijaki in že uveljavljeni umetniki, ki pod umetniškim vodstvom Lare Willewaldt in v organizaciji Kulturnega društva Odeon izvajajo najnovejšo slovensko komorno literaturo.\n" +
            "Njihova vizija je dolgoročna – širiti ljubezen do sodobne glasbe in mladim ustvarjalcem odpirati vrata v svet profesionalnega umetniškega ustvarjanja.\n",

        program1: [
            {
                skladatelj: "Blaž Pirnat (2004)",
                naslov: "Uvertura v globlji razmislek za flavto, oboo, klavir in godala"
            },
            {
                skladatelj: "Jurij Mušič (2003)",
                naslov: "Alma za sopran, klavir, flavto, oboo, saksofon in pozavno"
            },
            {
                skladatelj: "Miha Nahtigal (1994)",
                naslov: " Odsev za violino in ansambel"
            },
            {
                skladatelj: "Lenja Plajnšek (2006)",
                naslov: "Sestavljanka spominov za flavto, klavir in godala"
            },
            {
                skladatelj: "Simon Kravos (1999)",
                naslov: "Stvaritev za sopran in ansambel"
            },
            {
                skladatelj: "Otmar Taber (1997)",
                naslov: "Collage of times za ansambel"
            },
        ],
        izvajalci: [
            { ime: "Lara Willewaldt", instrument: "Dirigentka" },
            { ime: "Adna Cinac", instrument: "sopran" },
            { ime: "Nuša Dolinšek", instrument: "flavta" },
            { ime: "Anamarija Vuga", instrument: "oboa" },
            { ime: "Lan Meden", instrument: "saksofon" },
            { ime: "Rok Frančeškin", instrument: "trobenta" },
            { ime: "Ameli Kulovec Ulčnik", instrument: "pozavna" },
            { ime: "Eva Ostanek", instrument: "klavir" },
            { ime: "Timotej Willewaldt", instrument: "violina" },
            { ime: "Maša Stopar", instrument: "violina" },
            { ime: "Patricija Malovrh Mlačnik", instrument: "viola" },
            { ime: "Ariel Vei Atanasovski", instrument: "violončelo" }
        ],





        naslov4: "Mala mlada glasba: Arco",
        vsebina4: "Mala mlada glasba: Arco, ki je potekala leta 2024, je bila posvečena novim slovenskim skladbam za godalne zasedbe. V Baročni dvorani Radovljiške graščine so mladi skladatelji in skladateljice prvič predstavili svoja dela za godalni kvartet in sekstet, ki so nastala prav za to priložnost. Koncert je zaznamovala izjemna ustvarjalna raznolikost in tehnična zahtevnost novih del, v katerih so glasbeniki z veliko predanostjo predstavili sodobne poglede na komorno godalno glasbo.\n" +
            "Dogodek je izvedel Sekstet ansambla Glasba mladih, ki ga vodi Timotej Willewaldt.\n",
        naslov41: "O projektu Mala mlada glasba",
        vsebina41: "Mala mlada glasba je ciklus koncertov, zasnovan za spodbujanje ustvarjanja novih komornih skladb mladih slovenskih skladateljev. Podnaslov letošnjega koncerta, Arco (italijanski izraz za igranje z lokom), je napovedal poudarek na godalnih sestavih.\n" +
            "Dogodek je potekal pod okriljem Kulturnega društva Odeon, ki podpira mlado glasbeno ustvarjalnost in ponuja priložnosti za prve profesionalne izvedbe.\n",
        program4: [
            {
                skladatelj: "Dominik Jakšič (1995)",
                naslov: "Pet invencij za godalni sekste*"
            },
            {
                skladatelj: "Aleksej Kropej (2006)",
                naslov: "Pozabljeni odmevi za godalni sekstet"
            },
            {
                skladatelj: "Eva Ostanek (2000)",
                naslov: "  Swaying doloroso za godalni sekste*"
            },
            {
                skladatelj: "Matej Zupančič (2000)",
                naslov: "Larghetto za godalni kvartet*"
            },
            {
                skladatelj: "Jakob Korošec (2002) ",
                naslov: "Modalna raziskovanja za godalni sekstet*"
            },
            {
                skladatelj: "Matic Petek (2002)",
                naslov: "Godalni sekstet št. 1*"
            },
            {
                skladatelj: "Otmar Taber (1997)",
                naslov: "Reflections za godalni kvartet"
            },
            {
                skladatelj: "Andraž Babšek (2007)",
                naslov: "Po sledeh Zlatoroga za godalni kvartet"
            },
        ],
        izvajalci4: [
            { ime: "Timotej Willewaldt", instrument: "violina" },
            { ime: "Laura Calligaris", instrument: "violina" },
            { ime: "Tjaša Klanac", instrument: "viola" },
            { ime: "Izidora Krenn", instrument: "viola" },
            { ime: "Manca Kukovič", instrument: "violončelo" },
            { ime: "Izak Hudnik Zajec", instrument: "violončelo" },
        ],


    },
];
